import { Breadcrumb, Card, Layout, Row } from 'antd'
import StatsBlock from 'components/Purchasing/StatsBlock'
import React, { Fragment } from 'react'
import CustomCard from '../../elements/CustomCard'
import PageTitle from '../../elements/PageTitle'

const { Content } = Layout

function Dashboard() {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item href="#/purchasing/dashboard">Dashboard</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Purchasing Dashboard'}
              subtitle={'Purchasing Dashboard'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <div className="flex flex-row flex-wrap justify-around bg-white p-2 m-1 rounded-md">
            <StatsBlock
              {...{
                textColor: 'blue',
                background: 'blue',
                title: 'Requisitions',
                type: 'reqs',
              }}
            />
            <StatsBlock
              {...{
                textColor: 'cyan',
                background: 'cyan',
                title: 'RFQs',
                type: 'rfq',
              }}
            />
            <StatsBlock
              {...{
                textColor: 'green',
                background: 'green',
                title: 'Purchase',
                type: 'purchases',
              }}
            />
            <StatsBlock
              {...{
                textColor: 'red',
                background: 'red',
                title: 'Vouchers',
                type: 'vouchers',
              }}
            />

            <StatsBlock
              {...{
                textColor: 'pink',
                background: 'pink',
                title: 'Remittance',
                type: 'remittances',
              }}
            />
          </div>
          <CustomCard
            {...{
              title: 'Purchases And PayPlan Report',
              iconType: 'dollar',
              color: '#1A535C',
              linkTo: '/corporates/analytics/purchasesAndPayPlanReport',
              description: 'Access Your important document and operation.',
            }}
          />
        </Row>
      </Content>
    </Fragment>
  )
}

export default Dashboard
